// extracted by mini-css-extract-plugin
export default {"ddflx":"dropdown_ddflx__edVOf","vrot":"dropdown_vrot__vUb1z","frot":"dropdown_frot__griVQ","ddmain":"dropdown_ddmain__QzdxH"};